import { PartialSuccessResponse } from './partial-success.model';

export function hasFailedEntities(res: PartialSuccessResponse): boolean {
  return !!res?.failed?.length;
}
